// extracted by mini-css-extract-plugin
module.exports = {"root":"NeoHome_root__22SYy"};